import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app')({
  beforeLoad: async ({ context }) => {
    context.assertModuleAccess('core')
  },
})
